import { render, staticRenderFns } from "./ProjectionTips.vue?vue&type=template&id=6720e12a&"
import script from "./ProjectionTips.vue?vue&type=script&lang=ts&"
export * from "./ProjectionTips.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectionTips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports